
const ICONS_MAP = {
  ADVISING_ON_TECH: `${process.env.REACT_APP_ASSETS_BASE_URL}/home/icon-advising-on-technology.png`,
  POWER_IDEAS: `${process.env.REACT_APP_ASSETS_BASE_URL}/home/icon-powering-ideas-through-ui-ux.png`,
  RECOVER_STALLED_PRODUCTS: `${process.env.REACT_APP_ASSETS_BASE_URL}/home/icon-recovering-stalled-products.png`,
  SCALE_UP: `${process.env.REACT_APP_ASSETS_BASE_URL}/home/icon-scaleup-ready-apps.png`,
};

export const OUR_SPECIALTY: Array<{
  icon: string;
  title: string;
  subtitle: string;
}> = [
  {
    icon: ICONS_MAP.POWER_IDEAS,
    title: "Enhancing user experience",
    subtitle: "With scalable UI/UX design",
  },
  {
    icon: ICONS_MAP.RECOVER_STALLED_PRODUCTS,
    title: "Minimizing risks with",
    subtitle: "Data-driven decisions",
  },
  {
    icon: ICONS_MAP.SCALE_UP,
    title: "Strategizing technical",
    subtitle: "Upgrades for optimal performance",
  },
  {
    icon: ICONS_MAP.ADVISING_ON_TECH,
    title: "Reviving stalled SaaS to",
    subtitle: "Reignite growth",
  },
];
